import { IRefreshTokenResponse } from '@/interfaces/IRefreshTokenResponse'
import { SET_TOKEN } from '@/store/MUTATIONS-TYPES'
import store from '@/store/store'
import axios from 'axios'

export function createCancelationToken() {
	return axios.CancelToken.source()
}

/**
 * Recurso utilizado para fazer as chamadas de API da Atta.
 */
export class Http {
	static isRefreshing = false
	static failedRequestQueue: Array<any> = []

	/**
	 * Cria uma nova instancia do Axios
	 * @param baseUrl Url base do endpoint
	 */
	static create(baseUrl: string | undefined, headers: any = undefined) {
		var _http = axios.create({ baseURL: baseUrl })

		_http.defaults.headers.post['Content-Type'] = 'application/json'

		// O Interceptador irá inserir sempre o token de autorização durante a requisição

		_http.interceptors.request.use(
			(config) => {
				if (config.headers && config.headers['Authorization'] == undefined) {
					//@ts-ignore
					config.headers['Authorization'] = `Bearer ${store.state.user?.accessToken}`
				}

				return config
			},
			(error) => Promise.reject(error)
		)

		_http.interceptors.response.use(
			(response) => response,
			async (error) => {
				const status = error.response ? error.response.status : null

				if (status === 401) {
					const originalConfig = error.config

					this.failedRequestQueue.push(originalConfig)

					if (!this.isRefreshing) {
						this.isRefreshing = true

						try {
							var response = await _http.post<IRefreshTokenResponse>(
								`${import.meta.env.VUE_APP_API_AUTH}/connect/token`,
								{
									params: {
										client_id: 'ISolve',
										grant_type: 'refresh_token',
										refresh_token: store.state.user?.refreshToken
									}
								},
								{
									headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
								}
							)

							const { commit } = store
							commit(SET_TOKEN, response)
							this.failedRequestQueue.forEach((request: any) => _http(request))

							this.failedRequestQueue = []
							this.isRefreshing = false
						} catch {
							var cookies = document.cookie.split(';')
							for (var i = 0; i < cookies.length; i++) {
								var cookie = cookies[i]
								var eqPos = cookie.indexOf('=')
								var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
								document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
							}
							localStorage.clear()
							window.location.reload()
						}
					}
				}

				return Promise.reject(error)
			}
		)

		return _http
	}
}

export default Http
